import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import React, { useContext } from 'react';

import './style.scss';

const StatisticsPopup = (props) => {
  const [{ closePopup }] = useContext(PopupContext);
  const t = useTranslation();
  return (
    <div className="popup-content statistic-popup">
      <iframe title="statistic-popup" src={props.url} />
      <button
        type="button"
        className="popup-cancel-button"
        onClick={closePopup}
      >
        {t('Close')}
      </button>
    </div>
  );
};

export default StatisticsPopup;
